import { render, staticRenderFns } from "./myVillaStats.vue?vue&type=template&id=3875e910&scoped=true"
import script from "./myVillaStats.vue?vue&type=script&lang=js"
export * from "./myVillaStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875e910",
  null
  
)

export default component.exports